<div class="{{visible ? 'interpretation--open' : 'interpretation--closed'}}" (click)="toggleVisibility()" >{{interpretation?.title}} interpretation</div>
<div class="interpretation--expanded" *ngIf="visible">
  <div class="content" [innerHtml]="interpretation?.text | safeHtml"></div>
  <div class="download"><a [href]="interpretation?.doclink">{{'rulebook.interpretation_download' | transloco}}</a></div>
</div>
